import React from 'react';
import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { NumberInput, Text } from '@good/ui/core';

type QuantityInputProps = {
  defaultValue?: number;
  style?: Record<string, string>;
  name: FieldPath<FieldValues>;
};

export const ControlledQuantityInput = ({ name, style }: QuantityInputProps) => {
  const form = useFormContext<FieldValues>()

  return (
    <div style={style}>
      <Controller
        name={name}
        control={form.control}
        render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
          <>
            <NumberInput
              placeholder="Dollars"
              value={Number(value)}
              allowDecimal={true}
              onChange={onChange}
              mb="md"
              ref={ref}
              fixedDecimalScale
              decimalScale={2}
              min={1}
            />
            <Text c="red" pt="3px">{error?.message}</Text>
          </>
        )}
      />
    </div>
  )
}
